import React from 'react'
import PropTypes from 'prop-types'
import Utils from '../../../infra/Utils'

export default class PreviewTop extends React.Component {

  static propTypes = {
    invoiceEditor: PropTypes.object.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.left}>
          { this.props.invoiceEditor.getTitle() }
        </div>
        <div style={styles.right}>
          <div style={styles.dueLabel}>Amount Due</div>
          <div style={styles.amountLabel}>
            ${ Utils.getBillAmountDue(this.props.invoiceEditor.getBillingEntity()).toFixed(2) }
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: 120,
    color: '#fff'
  },
  left: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 4,
    paddingLeft: 32,
    fontSize: 32,
    backgroundColor: '#527da3'
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
    backgroundColor: '#356992'
  },
  dueLabel: {
    fontSize: 18
  },
  amountLabel: {
    fontSize: 32
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/PreviewTop.js